export default function trackMixPanelEvent(eventName, data = undefined) {
  if (window?.mixpanel && !window.location.pathname.includes('webview')) {
    window.mixpanel.track(eventName, { ...data });
  }
}
